/**
 * ★★★ A-6 (12/out/2026) — ÍCONES DO MENU, um por ITEM.
 *
 * ⚠⚠ O projeto **não tem biblioteca de ícones**, e isso está escrito no
 * `AppShell.jsx` desde os ícones de segmento: *"SVG inline porque o projeto não
 * tem biblioteca de ícones, e não vale acrescentar uma dependência inteira por
 * três glifos"*. ★★★ O dono pediu para usar "a biblioteca que o projeto já usa"
 * — ela não existe; o que existe é esta **convenção**: SVG inline, `24×24`,
 * `fill: none`, `stroke: currentColor`. ★ Então nenhuma dependência foi somada.
 *
 * ★★ OS DESENHOS SÃO OS DO DONO: cada `d` abaixo é copiado de
 * `docs/a6-desenho-menu.html`, o modelo que ele aprovou. ⚠ Não redesenhei nada —
 * um ícone "parecido" feito por mim tornaria a revisão do desenho inútil.
 *
 * ★★★ POR QUE EM ARQUIVO PRÓPRIO, e não no `AppShell.jsx` como os três de
 * segmento: são **21 ícones**. Inline, o `AppShell` passaria de 455 para ~800
 * linhas, e a estrutura do menu — que é o que se lê ali — ficaria soterrada.
 * ★ Os três de segmento ficam onde estão: eles são do shell, não dos itens.
 *
 * ⚠ `strokeWidth: 1.8` e não 2 (como no modelo HTML): é o traço que o resto do
 * app usa (`AppShell.jsx:traco` é 1.7; o chevron, 1.8). ★ Dois pesos de traço na
 * mesma barra apareceriam como dois desenhos de origens diferentes.
 */

const traco = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

/**
 * Molde de todos: 17px, `aria-hidden` e `focusable="false"`.
 *
 * ⚠ `aria-hidden` porque o rótulo ao lado JÁ diz o que é — um leitor de tela que
 * anuncia "gráfico, Dashboard" repete sem informar. ★ `focusable="false"` é para
 * o IE/Edge antigo não colocar o SVG na ordem de tabulação.
 */
const Svg = ({ children }) => (
  <svg
    className="nav-item-icone"
    width="17"
    height="17"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    {...traco}
  >
    {children}
  </svg>
);

/* ---------- Vendas / SDR ---------- */

export const IconeDashboard = () => (
  <Svg><path d="M3 3v18h18" /><path d="M18 17V9" /><path d="M13 17V5" /><path d="M8 17v-3" /></Svg>
);

/**
 * ★ O MESMO balão para os três canais de Conversas — e é decisão, não descuido.
 * ⚠ O `AppShell` já registrava: *"os três canais de Conversas são o mesmo
 * conceito, e qualquer ícone honesto para eles seria o mesmo balão"*. ★★ O
 * desenho do dono usa o mesmo `d` em "Conversas — Leads" e "Conversas — Recepção".
 */
export const IconeConversa = () => (
  <Svg><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></Svg>
);

export const IconeProximosContatos = () => (
  <Svg>
    <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z" />
  </Svg>
);

export const IconeFunil = () => (
  <Svg><path d="M22 3H2l8 9.5V19l4 2v-8.5z" /></Svg>
);

export const IconeAgenda = () => (
  <Svg><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></Svg>
);

export const IconeListaDeLeads = () => (
  <Svg><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" /></Svg>
);

export const IconeIndicadores = () => (
  <Svg><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></Svg>
);

export const IconeMetas = () => (
  <Svg>
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
  </Svg>
);

export const IconePlacar = () => (
  <Svg>
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18M4 22h16M10 14.7V17c0 .6-.5 1-1 1.2C7.8 18.8 7 20.2 7 22M14 14.7V17c0 .6.5 1 1 1.2 1.2.6 2 2 2 3.8M18 2H6v7a6 6 0 0 0 12 0z" />
  </Svg>
);

export const IconeMeuExtrato = () => (
  <Svg>
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1z" />
    <path d="M8 7h8M8 11h8M8 15h5" />
  </Svg>
);

/* ---------- seção Remuneração ---------- */

/** ★ O ícone da SEÇÃO (o `G:Remuneração` do desenho): cartão. */
export const IconeSecaoRemuneracao = () => (
  <Svg>
    <rect x="2" y="6" width="20" height="12" rx="2" /><circle cx="12" cy="12" r="2" />
    <path d="M6 12h.01M18 12h.01" />
  </Svg>
);

export const IconeRecebimentos = () => (
  <Svg><path d="M12 3v12M7 10l5 5 5-5M5 21h14" /></Svg>
);

export const IconeEmAberto = () => (
  <Svg><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></Svg>
);

export const IconeImportar = () => (
  <Svg><path d="M12 21V9M7 14l5-5 5 5M5 3h14" /></Svg>
);

export const IconeImportacoes = () => (
  <Svg><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5M12 7v5l4 2" /></Svg>
);

export const IconeRemuneracao = () => (
  <Svg>
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <path d="M8 6h8M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" />
  </Svg>
);

/* ---------- compartilhados ---------- */

/** ★ "Preferências" existe em Vendas E em Recepção — mesmo item, mesmo ícone. */
export const IconePreferencias = () => (
  <Svg><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" /></Svg>
);

/* ---------- Recepção ---------- */

export const IconeConfirmarAgenda = () => (
  <Svg>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18M9 16l2 2 4-4" />
  </Svg>
);

/* ---------- Administração ---------- */

export const IconeConfiguracoes = () => (
  <Svg>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
  </Svg>
);

export const IconeEquipe = () => (
  <Svg>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8" />
  </Svg>
);

/**
 * ⚠⚠ **"Painel SaaS" NÃO ESTÁ NO DESENHO** — o modelo do dono mostra o menu do
 * GESTOR, e esse item é do superadmin.
 *
 * ★ O dono pediu: *"se faltar algum, use o mais próximo e diga qual"*. ⚠ O mais
 * próximo em sentido seria a engrenagem de "Configurações", mas ela **já está
 * usada** — dois itens com o mesmo ícone na mesma barra deixam de informar.
 * ★★ Então: uma GRADE de quadrados (painel), no mesmo traço e no mesmo tamanho
 * da família. **Está registrado em `docs/a6-testes.md` para o dono trocar se
 * quiser.**
 */
export const IconePainelSaaS = () => (
  <Svg>
    <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />
  </Svg>
);
